import { useEffect, useState } from "react";
import { Alert, Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import DataService from "../services/data.service";

const CreateClient = () => {
  const [clientName, setClientName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    DataService.getUsers().then((response) => {
      setUsers(response.data);
    });
  }, []);

  const generateRandomId = () => {
    const generatedValue = Math.floor(Math.random() * 900000) + 100000;
    setAccountNumber(generatedValue);
  };

  const saveClient = () => {
    if (!clientName) {
      setFailMessage("Client name is required.");
      setSuccessMessage("");
      return;
    }

    if (!phoneNumber) {
      setFailMessage("Phone number is required.");
      setSuccessMessage("");
      return;
    }

    if (!accountNumber) {
      setFailMessage("Account number is required.");
      setSuccessMessage("");
      return;
    }

    if (!selectedUser) {
      setFailMessage("Select the primary portal user for this client.");
      setSuccessMessage("");
      return;
    }

    DataService.createClient(
      accountNumber.toString(),
      clientName,
      phoneNumber,
      selectedUser
    ).then(
      () => {
        setSuccessMessage("Client created successfully.");
        setFailMessage("");
        setAccountNumber("");
        setClientName("");
        setPhoneNumber("");
        setSelectedUser("");
      },
      (error) => {
        const responseMessage =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          error.toString();
        setFailMessage(responseMessage);
        setSuccessMessage("");
      }
    );
  };

  return (
    <div className="portal-page-stack">
      <section className="content-card content-card--padded page-form-card">
        <div className="section-heading">
          <div>
            <p className="section-heading__eyebrow">Client onboarding</p>
            <h4>Create a client account</h4>
          </div>
          <Link to="/clients" className="section-link">
            Back to clients
          </Link>
        </div>
        <p className="content-card__supporting">
          Set up the client profile, assign an account number, and attach the primary portal operator.
        </p>
        <Form>
          <div className="portal-form-grid portal-form-grid--stacked">
            <Form.Group controlId="createClientName">
              <Form.Label>Client name</Form.Label>
              <Form.Control type="text" value={clientName} onChange={(event) => setClientName(event.target.value)} />
            </Form.Group>
            <Form.Group controlId="createClientPhoneNumber">
              <Form.Label>Phone number</Form.Label>
              <Form.Control type="text" value={phoneNumber} onChange={(event) => setPhoneNumber(event.target.value)} />
            </Form.Group>
            <Form.Group controlId="createClientAccountNumber">
              <Form.Label>Account number</Form.Label>
              <div className="inline-control-row">
                <Form.Control type="text" disabled value={accountNumber} />
                <Button variant="outline-primary" onClick={generateRandomId}>
                  Generate
                </Button>
              </div>
            </Form.Group>
            <Form.Group controlId="createClientPrimaryUser">
              <Form.Label>Primary user</Form.Label>
              <Form.Control as="select" value={selectedUser} onChange={(event) => setSelectedUser(event.target.value)}>
                <option value="">Choose a user</option>
                {users.map((user) => (
                  <option value={user.users.id} key={user.users.id}>
                    {user.users.userName}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </div>
        </Form>
        <div className="button-row mt-4">
          <Button variant="primary" onClick={saveClient}>
            Save client
          </Button>
        </div>
        {failMessage ? <Alert variant="danger" className="mt-3 mb-0">{failMessage}</Alert> : null}
        {successMessage ? <Alert variant="success" className="mt-3 mb-0">{successMessage}</Alert> : null}
      </section>
    </div>
  );
};

export default CreateClient;
